/**
 * 重点！！！！
 * 此文件不允许手动修改，需要修改请联系vincecwu
 */
export default {
    version: '0.0.46'
}